module.exports = __webpack_public_path__ + "static/media/leadproject.0b7dca54.svg";